import type { Category } from '@wix/add-panel-common';
import { createContext } from 'react';
import type { Context } from './CurrentCategoryProvider.types';

export const CurrentCategoryContext = createContext<Context>({ category: {} as Category });
